import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent, setUserProperties } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// Removed getStorage - not used anywhere (saves ~50-100KB)

// Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Lazy initialize Firebase
let app;
let analytics;
let db;

// Initialize Firebase lazily
const initializeFirebase = () => {
  if (!app) {
    app = initializeApp(firebaseConfig);
    analytics = getAnalytics(app);
    db = getFirestore(app);
  }
  return { app, analytics, db };
};

// Analytics helper functions - lazy initialize Firebase when needed
export const logAnalyticsEvent = (eventName, parameters = {}) => {
  try {
    const { analytics } = initializeFirebase();
    if (analytics) {
      logEvent(analytics, eventName, parameters);
    }
  } catch (error) {
    console.error("Analytics error:", error);
  }
};

export const setAnalyticsUserProperties = (properties) => {
  try {
    const { analytics } = initializeFirebase();
    if (analytics && properties) {
      setUserProperties(analytics, properties);
    }
  } catch (error) {
    console.error("Analytics error:", error);
  }
};

// Export lazy getters for Firestore and Storage
export const getDb = () => {
  const { db } = initializeFirebase();
  return db;
};

// Removed getAppStorage - Storage not used (saves ~50-100KB bundle size)

export const getAppAnalytics = () => {
  const { analytics } = initializeFirebase();
  return analytics;
};